// Centralized company slug → hue + label map. PR 3 of the Ongoing Care
// build-out.
//
// These hues match the existing household-hero KPI pins
// (.household-hero-kpi-pin-{slug} in styles.css) so a company reads the
// same color everywhere — calendar cards, chips, pins. Centralizing here
// is the single source of truth the plan calls for (the CSS pins should
// migrate to consume these, but that's a non-blocking follow-up).
//
// Pure (no React) so it's usable from both components and node-pool tests.

export const COMPANY_HUES: Record<string, string> = {
  mortgage: "#4e98c6",
  insurance: "#022c51", // navy
  planning: "#5ba3d0",
  realty: "#3a7ea8",
  financial: "#2d627a",
};

export const COMPANY_LABELS: Record<string, string> = {
  mortgage: "Mortgage",
  insurance: "Insurance",
  planning: "Planning",
  realty: "Realty",
  financial: "Financial",
  productions: "Productions",
};

const FALLBACK_HUE = "#6b7684"; // --fg3 neutral

/** Hue for a company slug; neutral gray for unknown/null. */
export function companyHue(slug: string | null | undefined): string {
  if (!slug) return FALLBACK_HUE;
  return COMPANY_HUES[slug] ?? FALLBACK_HUE;
}

/** Display label for a company slug; Title-cased fallback for unknown.
 *  A null slug means firm-wide (no owning company). */
export function companyLabel(slug: string | null | undefined): string {
  if (!slug) return "Firm-wide";
  return (
    COMPANY_LABELS[slug] ??
    slug.charAt(0).toUpperCase() + slug.slice(1)
  );
}
